import { render, staticRenderFns } from "./notificationManagement.vue?vue&type=template&id=52b37293&scoped=true&"
import script from "./notificationManagement.vue?vue&type=script&lang=js&"
export * from "./notificationManagement.vue?vue&type=script&lang=js&"
import style0 from "./notificationManagement.vue?vue&type=style&index=0&id=52b37293&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b37293",
  null
  
)

export default component.exports